import React from 'react';
import { FileMono } from '@si/fib-icons';
import { Button, makeStyles } from '@fluentui/react-components';
import { t } from "i18next";
import { useNavigate } from 'react-router-dom';
import { navigateSafely } from '../../../utils/navigation';
import { isOutlookApp } from '../../../utils/Helper';
import { MailArchiveHome } from './MailArchiveHome';

const useStyles = makeStyles({
    ctnButton:
    {
        borderRadius: "4px",
        background: "#0F6CBD",
        color: 'white'
    },
    archiveBody:
    {
        padding: "24px",
        justifyContent: "flex-start",
        display: 'flex',
        flexDirection: 'column',
        paddingTop: "40%",
    },
    archiveHeading: {
        leadingTrim: "both",
        textEdge: "cap",
        fontStyle: "normal",
        fontFamily: "Segoe UI",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "normal",
        textAlign: 'center',
        display: "flex",
        alignItems: "center",
        gap: "8px",
        height: "24px"
    },
    buttonContainer: {
        display: 'flex',
        gap: '12px',
        flexDirection: 'column',
        alignItems: 'center'
    }

});


const ArchiveHome: React.FC = () => {
    const styles = useStyles();
    const navigate = useNavigate();


    return (
        <>
            {isOutlookApp() && <MailArchiveHome />}
            {!isOutlookApp() &&
                <div className={styles.archiveBody}>
                    <div className={styles.archiveHeading}>
                        <FileMono size={24} />
                        <span>&nbsp;{t('Not archived in 360°')}</span>
                    </div>
                    <p>{t('The selected file is currently not archived in 360°, click the button below to continue.')}</p>
                        <Button className={styles.ctnButton} onClick={() => navigateSafely(navigate, '/archiveFile')}>{t('Save to 360')}</Button>
                </div>
            }
        </>
    );
};

export default ArchiveHome;
